import './module_en.css';
import { useState } from 'react';
import { useServer } from "../../context/serverContext";
import { endpoints } from "../../env";
import { BarLoader } from '../../components/BarLoader/BarLoader';

const ModuleEnPopup = ({module}) => {
    const { postRequest ,getRequest } = useServer();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [title, setTitle] = useState('');
    const [loading, setLoading] = useState(true);
  
	const openModal = () => {
		setIsModalOpen(true);
		setLoading(true);
        getRequest(endpoints.moduleEn + module.id + '/en/get', {}, (res) => { 
          if (res[0]){
            const resI = res[1];
            console.log(resI);
            setTitle(resI.en.name);   
          }
          setLoading(false);
        });
	};

	const closeModal = () => {
		setIsModalOpen(false);
	};
   

	const handleSubmit = () => {
        let data = {
            name: title
        }
        postRequest(endpoints.updateModuleEn + module.id + '/en/update', data, (res) => { 
            if (res[0]) {
                closeModal();
            } else {
                closeModal();
            }
        });
  	};

    return (
        <div>
            <i className="fa-solid fa-language btn-en-module" onClick={openModal}></i>

			{isModalOpen && (
				<div className="modal" >
				<div className="modal-content">
				<h2 className='title-en-module'>English Module</h2>
				{loading && 
                    (
                        <div className='loader'>
                            <BarLoader />
                        </div>
                    )
                }
                
				<i className="fa-solid fa-circle-xmark icon-close" onClick={()=> closeModal() }></i>
					<div className='item-form-create-academy'>
					    <input type="text" placeholder="Course title" value={title} onChange={(e) => setTitle(e.target.value)}/>
					</div>
					
					<div className='item-form-create-academy'>
                        <button className='title-button' onClick={closeModal}>Cancel</button>
                        <button className='title-button' onClick={handleSubmit}>Save</button>
					</div>
				</div>
				</div>
			)}
		</div>
    );
}

export default ModuleEnPopup;
